(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-editorial-announcement]';

    const init = (section) => {
      if (!section || section.dataset.initialized === 'true') return;

      const messages = Array.from(section.querySelectorAll('[data-announcement-message]'));
      if (!messages.length) return;

      const previous = section.querySelector('[data-announcement-previous]');
      const next = section.querySelector('[data-announcement-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = section.dataset.autoplay === 'true';
      const interval = Number(section.dataset.interval) || 5000;
      let current = Math.max(messages.findIndex((message) => message.classList.contains('is-active')), 0);
      let timer;

      const show = (index) => {
        current = (index + messages.length) % messages.length;
        messages.forEach((message, messageIndex) => {
          const active = messageIndex === current;
          message.hidden = !active;
          message.classList.toggle('is-active', active);
        });
      };

      const stop = () => window.clearInterval(timer);

      const start = () => {
        stop();
        if (!autoplay || reducedMotion.matches || messages.length < 2) return;
        timer = window.setInterval(() => show(current + 1), interval);
      };

      previous?.addEventListener('click', () => {
        show(current - 1);
        start();
      });

      next?.addEventListener('click', () => {
        show(current + 1);
        start();
      });

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      reducedMotion.addEventListener('change', start);

      section.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('[data-announcement-message]');
        const selectedIndex = messages.indexOf(selected);
        if (selectedIndex > -1) show(selectedIndex);
        stop();
      });

      section.addEventListener('shopify:block:deselect', start);
      section.dataset.initialized = 'true';
      start();
    };

    const initAll = (root = document) => root.querySelectorAll(selector).forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
